'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { DOMAIN_INVALID, TARGET_PAGE_ERROR } from '../../constants/ErrorTypes';
import { getDomain } from '../../selectors/Grader';
var I18N_KEY = 'error';

var targetPageErrorSubtitle = function targetPageErrorSubtitle(domain) {
  return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: I18N_KEY + ".subtitles.targetPageError",
    options: {
      domain: domain
    }
  });
};

var websiteGraderErrorSubtitle = /*#__PURE__*/_jsx(FormattedHTMLMessage, {
  message: I18N_KEY + ".subtitles.websiteGraderError"
});

var ErrorDetails = function ErrorDetails() {
  var _useParams = useParams(),
      errorType = _useParams.errorType;

  var subtitle;

  switch (errorType) {
    case DOMAIN_INVALID:
    case TARGET_PAGE_ERROR:
      subtitle = targetPageErrorSubtitle(useSelector(getDomain));
      break;

    default:
      subtitle = websiteGraderErrorSubtitle;
      break;
  }

  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx("div", {
      className: "main-error-text",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: I18N_KEY + ".title"
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "error-subtitle",
      children: subtitle
    })]
  });
};

export default ErrorDetails;